export default function BlackHoleIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#86C96A" />
      <path d="M2 40h60v12H2z" fill="#5B6773" />
      <path d="M6 46h8M20 46h8M36 46h8M50 46h8" stroke="#F2F2F2" strokeWidth="2" />
      <rect x="40" y="8" width="18" height="26" fill="#6E8FA8" />
      <rect x="40" y="4" width="18" height="8" fill="#B8D4E8" />
      <path d="M43 15h4M51 15h4M43 21h4M51 21h4M43 27h4M51 27h4" stroke="#E1F3FF" strokeWidth="2.5" />
      <circle cx="12" cy="16" r="7" fill="#2E8B3D" />
      <rect x="10.5" y="20" width="3" height="7" fill="#7A5230" />
      <circle cx="28" cy="34" r="17" fill="#4FA8FF" />
      <circle cx="28" cy="34" r="14" fill="#0B0B14" />
      <path d="M20 30a9 9 0 0 1 12-5" stroke="#ffffff" strokeOpacity=".18" strokeWidth="2.5" strokeLinecap="round" />
      <g transform="rotate(-28 30 31)">
        <rect x="22" y="26" width="16" height="9" rx="3" fill="#E8443A" />
        <rect x="27" y="27.5" width="6" height="6" rx="1.5" fill="#BFE3FF" />
      </g>
    </svg>
  );
}
